var exports = {
  "Zp": "GuildServerTagTab.module__layout___RXVjSS",
  "Bo": "GuildServerTagTab.module__previewColumn___RXVjSS",
  "Em": "GuildServerTagTab.module__mainColumn___RXVjSS",
  "Lv": "GuildServerTagTab.module__intro___RXVjSS",
  "h_": "GuildServerTagTab.module__description___RXVjSS",
  "XB": "GuildServerTagTab.module__unlockButton___RXVjSS",
  "qK": "GuildServerTagTab.module__unlockHint___RXVjSS",
  "uW": "GuildServerTagTab.module__section___RXVjSS",
  "Gf": "GuildServerTagTab.module__sectionTitle___RXVjSS",
  "yD": "GuildServerTagTab.module__nameField___RXVjSS",
  "gK": "GuildServerTagTab.module__nameFieldDisabled___RXVjSS",
  "D3": "GuildServerTagTab.module__nameBadge___RXVjSS",
  "K3": "GuildServerTagTab.module__nameInput___RXVjSS",
  "aK": "GuildServerTagTab.module__hint___RXVjSS",
  "Ns": "GuildServerTagTab.module__infoNotice___RXVjSS",
  "IZ": "GuildServerTagTab.module__infoNoticeIcon___RXVjSS",
  "yq": "GuildServerTagTab.module__badgeGrid___RXVjSS",
  "Gk": "GuildServerTagTab.module__badgeCell___RXVjSS",
  "IN": "GuildServerTagTab.module__colorCell___RXVjSS",
  "PT": "GuildServerTagTab.module__badgeCellSelected___RXVjSS",
  "p0": "GuildServerTagTab.module__colorCellSelected___RXVjSS",
  "bh": "GuildServerTagTab.module__customColorCell___RXVjSS",
  "X1": "GuildServerTagTab.module__expandButton___RXVjSS",
  "B0": "GuildServerTagTab.module__previewCard___RXVjSS",
  "Vf": "GuildServerTagTab.module__previewTitle___RXVjSS",
  "tS": "GuildServerTagTab.module__previewChat___RXVjSS",
  "QS": "GuildServerTagTab.module__previewMessage___RXVjSS",
  "MM": "GuildServerTagTab.module__previewAvatar___RXVjSS",
  "Rd": "GuildServerTagTab.module__previewBody___RXVjSS",
  "q4": "GuildServerTagTab.module__previewNameRow___RXVjSS",
  "gz": "GuildServerTagTab.module__previewName___RXVjSS",
  "jv": "GuildServerTagTab.module__previewTag___RXVjSS",
  "at": "GuildServerTagTab.module__previewTagText___RXVjSS",
  "Wi": "GuildServerTagTab.module__previewText___RXVjSS",
};

module.exports = exports;
